import Vue from 'vue';

import VueRouter from 'vue-router';

import vueHeadful from 'vue-headful';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Vuelidate from 'vuelidate';

import App from './App.vue';
import { routes } from './routes';

import Menu from './components/Menu.vue';

import MenuSolicitud from './components/MenuSolicitud.vue';
import onlyNumbers from './directives/onlyNumbers';
import InsuranceService from './services/Insurance';
import SessionService from './services/Session';
import UserService from './services/User';
import PolicyService from './services/Policy';
import VehicleService from './services/Vehicles';
import BusinessPartnersService from './services/BussinessPartners';
import CURPyRFC from './services/CalcularRFCyCURP';
import CopomexService from './services/Copomex';
import SendWhatsappService from './services/SendWhatsapp';
import SiacService from './services/siac';
import UtilityService from './services/utility';
import LoteService from './services/lote';
import BancoService from './services/banco';
import StatusHistory from './services/statusHistory';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueMask from 'v-mask';
import Particles from "vue2-particles";

import Card from 'card';


import 'regenerator-runtime/runtime'

Vue.$SessionService = SessionService;
Vue.$UserService = UserService;
Vue.$InsuranceService = InsuranceService;
VueRouter.$PolicyService = PolicyService;
VueRouter.$VehicleService = VehicleService;
VueRouter.$BusinessPartnersService = BusinessPartnersService;
VueRouter.$CopomexService = CopomexService;
VueRouter.$SendWhatsappService = SendWhatsappService;
VueRouter.$CURPyRFC = CURPyRFC;
VueRouter.$SiacService = SiacService;
VueRouter.$UtilityService = UtilityService;
VueRouter.$LoteService = LoteService;
VueRouter.$BancoService = BancoService;
VueRouter.$StatusHistory = StatusHistory;

Object.defineProperty(Vue.prototype, '$SessionService', {
  get() { return SessionService }
});
Object.defineProperty(Vue.prototype, '$UserService', {
  get() { return UserService }
});
Object.defineProperty(Vue.prototype, '$InsuranceService', {
  get() { return InsuranceService }
});
Object.defineProperty(Vue.prototype, '$PolicyService', {
  get() { return PolicyService }
});
Object.defineProperty(Vue.prototype, '$VehicleService', {
  get() { return VehicleService }
});
Object.defineProperty(Vue.prototype, '$BusinessPartnersService', {
  get() { return BusinessPartnersService }
});
Object.defineProperty(Vue.prototype, '$CopomexService', {
  get() { return CopomexService }
});
Object.defineProperty(Vue.prototype, '$SendWhatsappService', {
  get() { return SendWhatsappService }
});
Object.defineProperty(Vue.prototype, '$CURPyRFC', {
  get() { return CURPyRFC }
});
Object.defineProperty(Vue.prototype, '$SiacService', {
  get() { return SiacService }
});
Object.defineProperty(Vue.prototype, '$UtilityService', {
  get() { return UtilityService }
});
Object.defineProperty(Vue.prototype, '$LoteService', {
  get() { return LoteService }
});
Object.defineProperty(Vue.prototype, '$BancoService', {
  get() { return BancoService }
});
Object.defineProperty(Vue.prototype, '$StatusHistory', {
  get() { return StatusHistory }
});

Vue.use(Particles);
Vue.use(VueMask);
Vue.use(VueSweetalert2);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(Card);
Vue.component('vue-headful', vueHeadful);
Vue.component('menu-component', Menu);

Vue.component('menu-solicitud', MenuSolicitud);
Vue.component('loading', Loading);

Vue.directive('only-numbers', onlyNumbers);

const router = new VueRouter({
  mode: 'history',
  routes: routes
});


router.beforeEach((to, from, next) => {
  const isAuthenticated = function () {
    const session = localStorage.getItem('session');

    return (session != undefined && session != '' && session != null)
  }

  switch (to.name) {
    case 'Login':
      if (!isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'CreateAccount':
      if (!isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'GrayZone':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'pdfGrayZone':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'contrato':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'contratoextras':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'contratoArrendamiento':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'SolicitudFondeo':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'ContratoFactura':
      if (isAuthenticated())
        next();
      else
        next({ name: 'PreApproval' });
      break;
    case 'PreApproval':
      if (isAuthenticated())
        next();
      else
        next({ name: 'Login' });
      break;
    case 'CartaFactura':
      if (isAuthenticated())
        next();
      else
        next({ name: 'Login' });
      break;
    case 'CaratulaCredito':
      if (isAuthenticated())
        next();
      else
        next({ name: 'Login' });
      break;
    case 'pagareFederatario':
      if (isAuthenticated())
        next();
      else
        next({ name: 'Login' });
      break;
    case 'ContratoEmpleado':
      if (isAuthenticated())
        next();
      else
        next({ name: 'Login' });
      break;
    default:
      next();
      break;
  }
});

new Vue({
  router: router,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js